module.exports = __webpack_public_path__ + "static/img/back_index.fc6e426.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/collection/back_index.png
// module id = xaHd
// module chunks = 4